import React, {
  createContext,
  useContext,
  useRef,
  useState,
  useCallback,
} from "react";

const PlayerCtx = createContext(null);

export const VideoPlayerProvider = ({ children }) => {
  const [videoId, setVideoId] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const playerRef = useRef(null); // instancia de la IFrame API de YouTube

  const play = useCallback((id) => {
    if (!id) return;
    setVideoId(id);
    setIsVisible(true);
    setIsExpanded(false);
  }, []);

  const pause = useCallback(() => {
    try {
      playerRef.current?.pauseVideo();
    } catch {}
    setIsPlaying(false);
  }, []);

  const resume = useCallback(() => {
    try {
      playerRef.current?.playVideo();
    } catch {}
    setIsPlaying(true);
  }, []);

  const stop = useCallback(() => {
    try {
      playerRef.current?.stopVideo();
    } catch {}
    setIsPlaying(false);
    setVideoId(null);
    setIsVisible(false);
    setIsExpanded(false);
  }, []);

  const expand = useCallback(() => setIsExpanded(true), []);
  const minimize = useCallback(() => setIsExpanded(false), []);

  const setPlayerObject = useCallback((ytPlayerObj) => {
    playerRef.current = ytPlayerObj;
  }, []);

  const value = {
    videoId,
    isVisible,
    isPlaying,
    isExpanded,
    play,
    pause,
    resume,
    stop,
    expand,
    minimize,
    setPlayerObject,
    setIsPlaying, // para actualizar desde eventos del player
  };

  return <PlayerCtx.Provider value={value}>{children}</PlayerCtx.Provider>;
};

export const useVideoPlayer = () => {
  const ctx = useContext(PlayerCtx);
  if (!ctx)
    throw new Error("useVideoPlayer must be used within VideoPlayerProvider");
  return ctx;
};
